export const renderColumnLabel = (column, options = {}) => {
  const { sortConfig, onCoachSkillSort, onCoachLeadershipSort } = options


  if (column.key === 'user') {
    return (
      <span
        className="headerIcon"
        title="Flag of managers country. Press flag to move managers page"
        aria-label="Flag of managers country. Press flag to move managers page"
      >
        Username
      </span>
    )
  }

  if (column.key === 'fanClub') {
    return 'Fans'
  }

  if (column.key === 'specialtyCount') {
    return 'Specialties'
  }

  if (column.key === 'youth') {
    const tooltip = 'T means Youth Team. N means Scouting Network. A number means the highest salary of an 18-19-year-old player promoted from youth.'

    return (
      <span title={tooltip} aria-label={tooltip}>
        {column.label}
      </span>
    )
  }

  if (column.key === 'hatstats') {
    return 'Hat stats'
  }

  if (column.key === 'powerRating') {
    return 'Pwr Rtng'
  }

  if (column.key === 'avgStamina') {
    return 'Avg Stamina'
  }

  if (column.key === 'avgForm') {
    return 'Avg Form'
  }

  if (column.key === 'coach') {
    return (
      <span className="coachHeader" aria-label="Coach sorting controls">
        <span>Coach</span>
        <span className="coachSortRow">
          <button
            type="button"
            className={`coachSortButton ${sortConfig?.key === 'coachSkill' ? 'active' : ''}`}
            onClick={onCoachSkillSort}
            title="Sort by highest coach level"
            aria-label="Sort by highest coach level"
          >
            ↑
          </button>
          <button
            type="button"
            className={`coachSortButton ${sortConfig?.key === 'coachLeadership' ? 'active' : ''}`}
            onClick={onCoachLeadershipSort}
            title="Sort by highest leadership"
            aria-label="Sort by highest leadership"
          >
            ↥
          </button>
        </span>
      </span>
    )
  }

  return column.label
}

export const getColumnClassName = columnKey => {
  if (columnKey === 'series') {
    return 'lastColumn'
  }

  if (columnKey === 'teamName') {
    return 'teamNameColumn'
  }

  if (columnKey === 'cup') {
    return 'cupColumn'
  }

  if (columnKey === 'cupSeed') {
    return 'cupSeedColumn'
  }

  if (columnKey === 'inheritedCupSeed') {
    return 'inheritedCupSeedColumn'
  }

  if (columnKey === 'remainingCupSeed') {
    return 'remainingCupSeedColumn'
  }

  if (columnKey === 'user') {
    return 'userColumn'
  }

  if (columnKey === 'discordSelect') {
    return 'discordColumn'
  }

  return ''
}
